'use client';

import { Card, Heading, Picture, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';

import { COLOR_TABLE, STORYTELLING_CARD_VARIANTS } from '../../../../constants';
import { cutText } from '../../../../utils/cutText';
import { propsImageItems } from '../../../../utils/propsImagesItems';
import type { StorytellingHeroCardProps } from '../types';
import './HeroCard.scss';

export default function HeroCard({
    header,
    bodyText,
    image,
    link,
    preheader,
    variant,
    textColor = 'Dark Grey',
    onClick,
}: StorytellingHeroCardProps) {
    const imageItems = propsImageItems(image);
    const blockTextColor = { color: COLOR_TABLE[textColor] };

    const Component = link ? Link : 'div';

    return (
        <Component
            href={link?.webUrl ?? ''}
            className="storytelling-card-up"
            data-testid="storytelling-card-up"
            onClick={onClick}
            prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
        >
            <Card className={`storytelling-card-up__${STORYTELLING_CARD_VARIANTS[variant]}`}>
                <Card.Header>
                    <Picture imgAlt={image.webAltText} imgSrc={imageItems[0]?.srcSet} items={imageItems} />
                </Card.Header>
                <Card.Body>
                    {preheader && STORYTELLING_CARD_VARIANTS[variant] === 'hero-tile' && (
                        <TextPassage style={blockTextColor}>{cutText(preheader, 15)}</TextPassage>
                    )}
                    <Heading tagName="h3" size="title" style={blockTextColor}>
                        {header}
                    </Heading>
                    {bodyText && STORYTELLING_CARD_VARIANTS[variant] === 'hero' && (
                        <TextPassage style={blockTextColor}>{cutText(bodyText, 70)}</TextPassage>
                    )}
                </Card.Body>
            </Card>
        </Component>
    );
}
